module.exports = __webpack_public_path__ + "static/media/insurance-claim-image.0e226c9f.png";